import React, { useState, useEffect } from 'react';
import Modal from '../../ui/Modal';
import Button from '../../ui/Button';
import Input from '../../ui/Input';
import FormField from '../../ui/FormField';

/**
 * Modal para adicionar ou editar categorias
 * 
 * @param {boolean} isOpen - Controla se o modal está aberto
 * @param {function} onClose - Função chamada ao fechar o modal
 * @param {object} category - Categoria a ser editada (null para criar nova)
 * @param {function} onSave - Função chamada ao salvar a categoria
 * @param {boolean} isSaving - Indica se está salvando (para desabilitar botões)
 */
const CategoryModal = ({ isOpen, onClose, category, onSave, isSaving = false }) => {
  // Estados para os campos do formulário
  const [nome, setNome] = useState('');
  const [descricao, setDescricao] = useState('');
  const [error, setError] = useState(null);

  // Preencher o formulário quando a categoria muda
  useEffect(() => {
    if (category) {
      setNome(category.nome || '');
      setDescricao(category.descricao || '');
    } else {
      // Valores padrão para nova categoria
      setNome('');
      setDescricao('');
    }
    
    setError(null);
  }, [category]);

  // Validar e salvar a categoria
  const handleSave = (e) => {
    e.preventDefault();
    
    // Validação básica
    if (!nome.trim()) {
      setError('Nome da categoria é obrigatório');
      return;
    }
    
    // Preparar dados da categoria
    const categoryData = {
      nome: nome.trim(),
      descricao: descricao.trim()
    };
    
    // Chamar função de salvar
    onSave(categoryData);
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={category ? "Editar Categoria" : "Adicionar Categoria"}
    >
      <form onSubmit={handleSave} className="space-y-4">
        {error && (
          <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded">
            {error}
          </div>
        )}
        
        <FormField label="Nome">
          <Input
            value={nome}
            onChange={(e) => setNome(e.target.value)}
            placeholder="Nome da categoria"
            required
            disabled={isSaving}
          />
        </FormField>
        
        <FormField label="Descrição">
          <Input
            value={descricao}
            onChange={(e) => setDescricao(e.target.value)}
            placeholder="Descrição (opcional)"
            disabled={isSaving}
          />
        </FormField>
        
        <div className="flex justify-end space-x-2 mt-4">
          <Button 
            type="button"
            variant="outline" 
            onClick={onClose}
            disabled={isSaving}
          >
            Cancelar
          </Button>
          <Button 
            type="submit"
            disabled={isSaving}
          >
            {isSaving ? 'Salvando...' : 'Salvar'}
          </Button>
        </div>
      </form>
    </Modal>
  );
};

export default CategoryModal; 